module.exports = __webpack_public_path__ + "static/media/DINNextLTProLightCond.ed33f2bd.woff";